import { searchCredentialAPI } from "services/apis.service";

const getErrorMessage = (error, fallback) =>
  error.response?.data?.message ||
  error.response?.data?.error ||
  error.response?.data?.errors?.join?.(" ") ||
  error.response?.data ||
  fallback;

const normalizeApiResponse = (payload, fallback) => {
  if (payload?.success === false) {
    return {
      success: false,
      data: payload.data ?? null,
      error:
        payload.errors?.join?.(" ") ||
        payload.message ||
        "The search provider credentials could not be verified.",
    };
  }

  return {
    success: true,
    data: payload?.data ?? payload,
    error: null,
    fallback,
  };
};

export class SearchCredentialService {
  #axios;

  constructor(axiosInstance) {
    this.#axios = axiosInstance;
  }

  async saveCredential({
    credentialType,
    username,
    password = "",
    profile = null,
    isEnabled,
  }) {
    try {
      const { data } = await this.#axios.post(
        searchCredentialAPI.save,
        {
          credentialType,
          username,
          password,
          profile,
          isEnabled,
        },
        { cache: false }
      );

      return normalizeApiResponse(
        data,
        `We couldn't verify the ${credentialType} credentials.`
      );
    } catch (error) {
      console.error(error);
      return {
        success: false,
        error: getErrorMessage(
          error,
          `We couldn't verify the ${credentialType} credentials. Please check them and try again.`
        ),
      };
    }
  }

  async getCredentials(type = null) {
    try {
      const { data } = await this.#axios.get(searchCredentialAPI.get, {
        params: { type },
        cache: false,
      });

      return normalizeApiResponse(data, "Unable to load search credentials.");
    } catch (error) {
      console.error(error);
      return {
        success: false,
        data: null,
        error: getErrorMessage(error, "Unable to load search credentials."),
      };
    }
  }

  async deleteCredential(id) {
    try {
      const { data } = await this.#axios.delete(searchCredentialAPI.delete, {
        params: { id },
        cache: false,
      });

      return normalizeApiResponse(data, "Unable to delete search credentials.");
    } catch (error) {
      console.error(error);
      return {
        success: false,
        error: getErrorMessage(error, "Unable to delete search credentials."),
      };
    }
  }
}
